import { InputOTP } from './input-otp';

const CustomOTP = {
    Root: InputOTP,
};
export default CustomOTP;
